<template>
  <v-app id="inspire">
    <div>
      <v-layout class="mb-4">
        <v-flex>
          <h2 class="headline">Route Planning Report</h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn
          class="mx-0 mb-0"
          text
          small
          :disabled="loading || items.length === 0"
          @click="exportCSV"
          ><v-icon class="mr-1">cloud_download</v-icon> CSV
        </v-btn>
      </v-layout>
      <div>
        <v-container container--fluid class="grid-list-md pa-0 mb-4">
          <v-layout class="wrap xs12">
            <v-flex class="xs12 sm6 md2" style="min-width: 200px;">
              <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="selectedDate"
                    label="Date"
                    prepend-icon="event"
                    readonly
                    placeholder="Please Select"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedDate"
                  no-title
                  @input="menu1 = false"
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="xs12 sm6 md1">
              <v-btn
                @click="initialize"
                large
                color="#00838F"
                dark
                class="mx-0"
                style="min-width: 50px; padding: 0 10px;"
              >
                Go
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :disable-pagination="true"
          :loading="loading"
          loader-height="2"
          class="elevation-1 table-org"
          hide-default-footer
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr class="items-body-row">
              <td>
                <span v-if="!no_data.includes(item.assigned_to_name)">{{ item.assigned_to_name }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.duration)">{{ formatTimeDuration(item.duration) }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.driving_time)">{{ formatTimeDuration(item.driving_time) }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.distance)">{{ formatKmToMi(item.distance) }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.cleanup_time)">{{ formatTimeDuration(item.cleanup_time) }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <span v-if="!no_data.includes(item.number_of_jobs)">{{ item.number_of_jobs }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>
<script>
import ApiService from "@/common/api.service";
import EventBus from '@/main';

export default {
  name: "RoutePlaningReport",
  data: () => ({
    no_data: [null, "", undefined, "null"],
    menu1: false,
    items: [],
    loading: false,
    options: {},
    headers: [
      { text: "Field Tech Name", value: "assigned_to_name", sortable: false },
      { text: "Est. Route Duration", value: "duration", sortable: false },
      { text: "Est. Driving Time", value: "driving_time", sortable: false },
      { text: "Distance", value: "distance", sortable: false },
      { text: "Est. Cleanup Time", value: "cleanup_time", sortable: false },
      { text: "Number of Jobs", value: "number_of_jobs", sortable: false }
    ],
    selectedDate: moment().format("YYYY[-]MM[-]DD"),
    loadedDate: null,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong..."
  }),
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loading = true;
      ApiService.get("/scheduler/route_planning_report", { date: this.selectedDate})
        .then(response => {
          this.items = response.data.route_reports
          this.loadedDate = this.selectedDate
          this.loading = false;
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
        // .catch(({ response }) => {
        //   this.loading = false;
        //   this.serverValidation = false;
        //   if (response.data.error) {
        //     this.serverValidationMessage = this.titleCase(response.data.error);
        //   }
        //   if (response.data.message) {
        //     this.serverValidationMessage = response.data.message;
        //   }
        //   if (response.data.errors) {
        //     this.server_errors = response.data.errors;
        //   }
        // });
    },
    exportCSV() {
      let csvContent = "";
      let headers = [];
      let csvData = [];
      this.headers.forEach(i => {
        if (i.text != "Actions") {
          headers.push(i.text);
        }
      });
      headers.map(i => `"${i}"`);
      this.items.forEach(i => {
        let row = {
          field_tech_name: !this.no_data.includes(i.assigned_to_name)
            ? `"${i.assigned_to_name}"`
            : `""`,
          duration: !this.no_data.includes(i.duration)
            ? `"${ this.formatTimeDuration(i.duration)}"`
            : `""`,
          driving_time: !this.no_data.includes(i.driving_time)
            ? `"${this.formatTimeDuration(i.driving_time)}"`
            : `""`,
          distance: !this.no_data.includes(i.distance)
            ? `"${ this.formatKmToMi(i.distance) }"`
            : `""`,
          cleanup_time: !this.no_data.includes(i.cleanup_time)
            ? `"${ this.formatTimeDuration(i.cleanup_time) }"`
            : `""`,
          number_of_jobs: !this.no_data.includes(i.number_of_jobs)
            ? `"${i.number_of_jobs}"`
            : `""`,
        };
        csvData.push(row);
      });

      csvContent += [
        headers.join(","),
        ...csvData.map(item => Object.values(item).join(","))
      ].join("\n").replace(/(^\[)|(\]$)/gm, "")

      const data = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(data)
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `Route Planning Report - ${this.loadedDate}.csv`
      );
      link.click();
    },
    formatKmToMi(km) {
      let n = (km / 1.609344).toFixed(2);
      let number = Number(n);
      return `${number.toString()} mi`;
    },
    formatTimeDuration(m) {
      let hours = 0;
      let minutes = 0;
      let hours_out = "";
      let minutes_out = "";
      hours = Math.floor(m / 60);
      minutes = m % 60;
      if (hours > 0) {
        hours_out = `${hours} hr`;
      }
      if (minutes > 0 || (hours === 0 && minutes === 0)) {
        minutes_out = `${minutes} min`;
      }
      return `${hours_out}${hours > 0 && minutes > 0 ? " " : ""}${minutes_out}`;
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    upperFirst(str) {
      return _.upperFirst(str);
    }
  }
};
</script>

<style>
</style>
